import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MomentPipeModule } from "../resources/pipes/moment-pipe/moment-pipe.module";
import { NumeralPipeModule } from "../resources/pipes/numeral-pipe/numeral-pipe.module";

@NgModule({
  declarations: [],
  exports: [
    MomentPipeModule,
    NumeralPipeModule
  ],
  imports: [
    CommonModule,
    MomentPipeModule,
    NumeralPipeModule
  ]
})
export class SharedModule { }
